export default __webpack_public_path__ + "static/media/026-pedestrian crossing.21ccb02a.png";